export default __webpack_public_path__ + "static/media/safety-certificate.568d6280.svg";